module.exports = __webpack_public_path__ + "img/Teutonia-WG.0f972491.jpeg";